import store from '@/store';

export default (to, from, next) => {
    store.dispatch('get_is_module_ufb_enabled').catch(() => {});

    const ufbEnabled = store.getters.is_show_ufb_module;
    const fwaEnabled = store.getters.is_show_fwa_module;
    const allow = ufbEnabled || fwaEnabled;

    return {
        allow,
        redirect: { name: 'not-found' },
    };
}
